export default "__VITE_PUBLIC_ASSET__502aaacc__"